import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box } from 'enova-frontend-components';

import { PlasseringAvEnhetIByggHorisontalt } from '../../../../../utils/registerEnums';
import { AboutFormData } from '../../types';
import { EnumRadioGroup } from '../../heating/components/enumRadioGroup';
import { EnumRadioButton } from '../../heating/components/enumRadioButton';

interface HorizontalPlacementRadioProps {
  control: Control<AboutFormData>;
  options: PlasseringAvEnhetIByggHorisontalt[];
  i18nPrefix: string;
}

// Leilighet and Rekkehus
export const HorizontalPlacementRadio: FC<HorizontalPlacementRadioProps> = ({ control, i18nPrefix, options }) => {
  return (
    <Controller
      name="bygginfo.horizontalPlacement"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <EnumRadioGroup value={value} onChange={onChange} error={error} labelKey={`${i18nPrefix}.label`}>
          <Box display="flex" flexWrap="wrap" gap={2}>
            {options.map((option) => (
              <EnumRadioButton key={option} value={option} i18nPrefix={`${i18nPrefix}.option`} />
            ))}
          </Box>
        </EnumRadioGroup>
      )}
    />
  );
};

export const HorizontalPlacementApartment: FC<{
  control: Control<AboutFormData>;
}> = ({ control }) => {
  const i18nPrefix = 'register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggHorisontalt';

  const leilighetOptions = [
    PlasseringAvEnhetIByggHorisontalt.Endeleilighet,
    PlasseringAvEnhetIByggHorisontalt.FrittstaendeLeilighet,
    PlasseringAvEnhetIByggHorisontalt.Hjorneleilighet,
    PlasseringAvEnhetIByggHorisontalt.Midtleilighet
  ];

  return <HorizontalPlacementRadio control={control} options={leilighetOptions} i18nPrefix={i18nPrefix} />;
};

export const HorizontalPlacementRekkehusRadio: FC<{
  control: Control<AboutFormData>;
}> = ({ control }) => {
  const i18nPrefix = 'register.bygningsdetaljer.rekkehus.plasseringAvEnhetIByggHorisontalt';

  const rekkehusOptions = [
    PlasseringAvEnhetIByggHorisontalt.Enderekkehus,
    PlasseringAvEnhetIByggHorisontalt.Midtrekkehus
  ];

  return <HorizontalPlacementRadio control={control} options={rekkehusOptions} i18nPrefix={i18nPrefix} />;
};
